export const searchTooltipText = 'Search by file name';

export const deleteConfirmText = 'Are you sure you want to delete the file(s)?';

export const attachFilesTooltip = 'Attach to a milestone';

export const attachFilesTooltipDisabled = 'To attach a milestone, please create one first';
